<template>
  <div id="ruleCriteriaAutocomplete">
    <v-progress-circular
      v-if="isLoading"
      color="primary"
      indeterminate
    />
    <template v-if="!isLoading">
      <v-autocomplete
        :ref="'autoComplete' + structureItem.criteriaStructureId"
        v-model="selectedObject"
        :item-value="
          (item) =>
            item.criteriaListEntryId ? item.criteriaListEntryId : item.value
        "
        :items="possibleValues"
        class="wizardAutocomplete"
        item-text="value"
        return-object
        @change="updateProperty()"
      />
    </template>
    <div
      v-if="!isLoading && possibleValues.length == 0"
      class="mt-4"
    >
      keine Auswahl möglich
    </div>
  </div>
</template>

<script>
import { GetPossibleStructureValues } from "@/services/minimum.wage.services/criteria.minimum.wages.js";

export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    allValues: {
      type: Object,
      default: () => {},
    },
    structureItem: {
      type: Object,
      default: () => {},
    },
    contractId: {
      type: String,
      default: () => "",
    },
    versionNumber: {
      type: Number,
      required: true,
    },
    editionId: {
      type: Number,
      required: true,
    },
    collectionName: {
      type: String,
      required: true,
    },
    titleUpdated: {
      type: Boolean,
      default: () => true,
    },
    loadFullyQualifiedPaths: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueCopy: [],
      possibleValues: [],
      selectedObject: {},
      configurationType: 0,
      isLoading: false,
      noChoicePossible: false,
    };
  },
  watch: {
    allValues(newValue, oldValue) {
      var oldValuePreviousProps = this.getAllPreviousProperties(oldValue);
      var newValuePreviousProps = this.getAllPreviousProperties(newValue);

      this.valueCopy = JSON.parse(JSON.stringify(this.value));

      // if a previous property has changed, we need to recalculate all possible options
      if (
        JSON.stringify(oldValuePreviousProps) !=
        JSON.stringify(newValuePreviousProps)
      ) {
        this.getAllPossibleOptions();
      }
    },
    titleUpdated() {
      this.valueCopy = JSON.parse(JSON.stringify(this.value));
    },
  },
  created() {
    this.valueCopy = JSON.parse(JSON.stringify(this.allValues));
    if (
      this.$store.state.mindestLohnKonfiguration.Criteria.filter((value) => {
        return (
          value.criteriaStructureId == this.structureItem.criteriaStructureId
        );
      })
    ) {
      this.configurationType =
        this.$store.state.mindestLohnKonfiguration.Criteria.filter((value) => {
          return (
            value.criteriaStructureId == this.structureItem.criteriaStructureId
          );
        })[0].type;
    }
    this.getAllPossibleOptions();

    if (this.valueCopy != null) {
      this.selectedObject.value =
        this.valueCopy[this.collectionName][
          this.valueCopy[this.collectionName].indexOf(
            this.valueCopy[this.collectionName].filter((value) => {
              return (
                value.criteriaStructureId ==
                this.structureItem.criteriaStructureId
              );
            })[0],
          )
        ].value;
      this.selectedObject.criteriaListEntryId =
        this.valueCopy[this.collectionName][
          this.valueCopy[this.collectionName].indexOf(
            this.valueCopy[this.collectionName].filter((value) => {
              return (
                value.criteriaStructureId ==
                this.structureItem.criteriaStructureId
              );
            })[0],
          )
        ].criteriaListEntryId;
      this.selectedObject.criteriaStructureId =
        this.valueCopy[this.collectionName][
          this.valueCopy[this.collectionName].indexOf(
            this.valueCopy[this.collectionName].filter((value) => {
              return (
                value.criteriaStructureId ==
                this.structureItem.criteriaStructureId
              );
            })[0],
          )
        ].criteriaStructureId;
      this.selectedObject.path =
        this.valueCopy[this.collectionName][
          this.valueCopy[this.collectionName].indexOf(
            this.valueCopy[this.collectionName].filter((value) => {
              return (
                value.criteriaStructureId ==
                this.structureItem.criteriaStructureId
              );
            })[0],
          )
        ].path;
    }
  },
  methods: {
    updateProperty() {
      // this is a fix for a problem where the selected value does not show up until focus on the element is lost.
      this.$refs[
        "autoComplete" + this.structureItem.criteriaStructureId
      ].blur();
      this.valueCopy[this.collectionName][
        this.valueCopy[this.collectionName].indexOf(
          this.valueCopy[this.collectionName].filter((value) => {
            return (
              value.criteriaStructureId ==
              this.structureItem.criteriaStructureId
            );
          })[0],
        )
      ].value = this.selectedObject.value;
      this.valueCopy[this.collectionName][
        this.valueCopy[this.collectionName].indexOf(
          this.valueCopy[this.collectionName].filter((value) => {
            return (
              value.criteriaStructureId ==
              this.structureItem.criteriaStructureId
            );
          })[0],
        )
      ].criteriaListEntryId = this.selectedObject.criteriaListEntryId;
      this.valueCopy[this.collectionName][
        this.valueCopy[this.collectionName].indexOf(
          this.valueCopy[this.collectionName].filter((value) => {
            return (
              value.criteriaStructureId ==
              this.structureItem.criteriaStructureId
            );
          })[0],
        )
      ].criteriaPlzId = this.selectedObject.criteriaPlzId;
      this.valueCopy[this.collectionName][
        this.valueCopy[this.collectionName].indexOf(
          this.valueCopy[this.collectionName].filter((value) => {
            return (
              value.criteriaStructureId ==
              this.structureItem.criteriaStructureId
            );
          })[0],
        )
      ].path = this.selectedObject.path;

      // Take all current properties from parent, only replace the entries array from our local copy
      const updatedValue = {
        ...this.value,
        [this.collectionName]: this.valueCopy[this.collectionName],
      };

      this.$emit("input", updatedValue);
      this.$emit("valueChanged", updatedValue);
    },
    getAllPreviousProperties(allProperties) {
      var allStructureValues = [];

      if (allProperties == null) return allStructureValues;
      allProperties[this.collectionName].map((entry) => {
        if (entry.criteriaStructureId) {
          allStructureValues.push({
            criteriaStructureId: entry.criteriaStructureId,
            value: entry.value,
            criteriaListEntryId: entry.criteriaListEntryId,
          });
        }
      });

      return allStructureValues;
    },
    getAllOptions() {
      this.isLoading = true;
      this.possibleValues = [];
      GetPossibleStructureValues(
        this.contractId,
        this.versionNumber,
        this.editionId,
        this.structureItem.criteriaStructureId,
        [],
        this.validateConfigurationType(),
        this.loadFullyQualifiedPaths,
        (response) => {
          this.isLoading = false;
          this.possibleValues = JSON.parse(JSON.stringify(response));

          // Because it should be possible to not select any value, we add an empty element.
          this.possibleValues.unshift({
            value: "",
            criteriaListEntryId: null,
            criteriaStructureId: null,
          });

          var previousTitle =
            this.possibleValues[this.possibleValues.length - 1]
              .selectionGroupTitle;
          for (
            let index = this.possibleValues.length - 1;
            index >= 0;
            index--
          ) {
            if (
              previousTitle != this.possibleValues[index].selectionGroupTitle
            ) {
              this.possibleValues.splice(index + 1, 0, {
                header: previousTitle,
              });
              previousTitle = this.possibleValues[index].selectionGroupTitle;
            }
          }

          if (this.possibleValues.length == 0) {
            this.noChoicePossible = true;
            this.clearCurrentValue();
            this.$emit("noValuesPossible", true);
          } else {
            this.noChoicePossible = false;
            this.$emit("noValuesPossible", false);

            this.assureCurrentValueAvailable();
          }

          this.$emit("initialLoadCompleted");
        },
        () => {
          this.isLoading = false;
          this.noChoicePossible = true;
          this.$emit("noValuesPossible", true);
          this.clearCurrentValue();
          this.$emit("initialLoadCompleted");
        },
      );
    },
    getAllPossibleOptions() {
      this.isLoading = true;
      this.possibleValues = [];

      GetPossibleStructureValues(
        this.contractId,
        this.versionNumber,
        this.editionId,
        this.structureItem.criteriaStructureId,
        this.getAllPreviousProperties(this.valueCopy),
        this.validateConfigurationType(),
        this.loadFullyQualifiedPaths,
        (response) => {
          this.isLoading = false;
          if (
            response.length > 0 &&
            !(
              response.length == 1 &&
              response[0].criteriaListEntryId == null &&
              response[0].selectionGroupTitle == null &&
              response[0].criteriaPlzId == null &&
              response[0].value == null
            )
          ) {
            this.possibleValues = JSON.parse(JSON.stringify(response));

            // Because it should be possible to not select any value, we add an empty element.
            this.possibleValues.unshift({
              value: "",
              criteriaListEntryId: null,
              criteriaStructureId: null,
              criteriaPlzId: null,
            });

            if (this.possibleValues.length == 0) {
              this.noChoicePossible = true;
              this.clearCurrentValue();
              this.$emit("noValuesPossible", true);
            } else {
              this.noChoicePossible = false;
              this.$emit("noValuesPossible", false);

              this.assureCurrentValueAvailable();
            }
            this.getAllOptions();

            this.$emit("initialLoadCompleted");
          } else {
            this.getAllOptions();
          }
        },
        () => {
          this.getAllOptions();
        },
      );
    },
    assureCurrentValueAvailable() {
      var currentValueObject = this.possibleValues.filter((value) => {
        return value.value == this.selectedObject.value;
      });
      if (currentValueObject.length == 0) {
        this.clearCurrentValue();
      }
    },
    clearCurrentValue() {
      this.selectedObject.value = "";
      this.selectedObject.criteriaListEntryId = null;

      if (this.valueCopy != null) {
        this.valueCopy[this.collectionName][
          this.valueCopy[this.collectionName].indexOf(
            this.valueCopy[this.collectionName].filter((value) => {
              return (
                value.criteriaStructureId ==
                this.structureItem.criteriaStructureId
              );
            })[0],
          )
        ].value = this.selectedObject.value;
        this.valueCopy[this.collectionName][
          this.valueCopy[this.collectionName].indexOf(
            this.valueCopy[this.collectionName].filter((value) => {
              return (
                value.criteriaStructureId ==
                this.structureItem.criteriaStructureId
              );
            })[0],
          )
        ].criteriaListEntryId = this.selectedObject.criteriaListEntryId;
      }
      // Take all current properties from parent, only replace the entries array from our local copy
      this.$emit("input", {
        ...this.value,
        [this.collectionName]: this.valueCopy[this.collectionName],
      });
    },

    validateConfigurationType() {
      if (this.configurationType == 2 || this.configurationType == 3) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style>
.v-list-item__title,
.v-list-item__subtitle {
  overflow: auto !important;
  text-overflow: initial !important;
  white-space: normal !important;
}

.wizardAutocomplete .v-subheader {
  color: red;
}
</style>

<style lang="scss" scoped></style>
